import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import { ReactComponent as AirlineSeatIcon } from '../../../Assets/airline_seat_recline_extra.svg';
import { ReactComponent as RemarkIcon } from '../../../Assets/content_paste.svg';
import { ReactComponent as FlightIcon } from '../../../Assets/flight.svg';
import { ReactComponent as HotelIcon } from '../../../Assets/hotel.svg';
import { ReactComponent as LikeIcon } from '../../../Assets/like.svg';
import { ReactComponent as DiningIcon } from '../../../Assets/local_dining.svg';
import { ReactComponent as MedicineIcon } from '../../../Assets/medical_information.svg';
import { ReactComponent as ShelterIcon } from '../../../Assets/night_shelter.svg';
import { ReactComponent as NoFoodIcon } from '../../../Assets/no_food.svg';
import { ReactComponent as WarningIcon } from '../../../Assets/warning_amber.svg';
import { ReactComponent as HotTubIcon } from '../../../Assets/hot_tub.svg';

export const NeedTab = ({ traveler, isEditingNeeds, isSavingNeeds, handleListChange, onStartEditNeeds, onSaveNeeds, onCancelNeeds }) => {
	return (
		<div className="traveler-section">
			<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
				{isEditingNeeds ? (
					<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: 10 }}>
						<button
							type="button"
							className="button is-medium"
							style={{
								backgroundColor: '#22c65b',
								borderColor: '#22c65b',
								color: '#fff',
								opacity: isSavingNeeds ? 0.7 : 1,
							}}
							onClick={onSaveNeeds}
							disabled={isSavingNeeds}
							aria-label="บันทึก"
							title="บันทึก"
						>
							<FontAwesomeIcon icon={faCheck} />
						</button>
						<button
							type="button"
							className="button is-medium"
							style={{
								backgroundColor: '#DC1818',
								borderColor: '#DC1818',
								color: '#fff',
								opacity: isSavingNeeds ? 0.7 : 1,
							}}
							onClick={onCancelNeeds}
							disabled={isSavingNeeds}
							aria-label="ยกเลิก"
							title="ยกเลิก"
						>
							<FontAwesomeIcon icon={faTimes} />
						</button>
					</div>
				) : (
					<button
						type="button"
						className="button is-info is-medium"
						onClick={onStartEditNeeds}
						style={{ justifyContent: 'flex-end', marginBottom: 10 }}
						aria-label="แก้ไข"
						title="แก้ไข"
					>
						<FontAwesomeIcon icon={faPencilAlt} />
					</button>
				)}
			</div>
			<div className="columns">
				<div className="column is-6">
					<div className="traveler-section-title-container" />
					<div className="columns">
						<h2 className="traveler-section-title">ความต้องการ</h2>
						<div style={{ width: 10 }} />
						<LikeIcon className="traveler-icon" style={{ color: '#22c65b', marginTop: 3 }} />
					</div>

					<NeedItem
						icon={<DiningIcon className="traveler-icon" />}
						value={traveler.preferFood}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferFood', value)}
						placeholder="ความชอบอาหาร เครื่องดื่ม ฯลฯ"
					/>
					<NeedItem
						icon={<ShelterIcon className="traveler-icon" style={{ paddingRight: '2px' }} />}
						value={traveler.preferHotel}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferHotel', value)}
						placeholder="ชนิดของโรงแรม"
					/>
					<NeedItem
						icon={<HotelIcon className="traveler-icon" />}
						value={traveler.preferRoom}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferRoom', value)}
						placeholder="ชนิดของห้อง"
					/>
					<NeedItem
						icon={<HotTubIcon className="traveler-icon" />}
						value={traveler.preferBed}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferBed', value)}
						placeholder="ชนิดของเตียง"
					/>
					<NeedItem
						icon={<FlightIcon className="traveler-icon" />}
						value={traveler.preferAirline}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferAirline', value)}
						placeholder="สายการบิน"
					/>
					<NeedItem
						icon={<AirlineSeatIcon className="traveler-icon" />}
						value={traveler.preferSeat}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferSeat', value)}
						placeholder="ตำแหน่งที่นั่ง"
					/>
					<NeedItem
						icon={<RemarkIcon className="traveler-icon" />}
						value={traveler.preferEtc}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('preferEtc', value)}
						placeholder="ความต้องการอื่นๆ"
					/>
				</div>
				<div className="column is-6">
					<div className="columns">
						<h2 className="traveler-section-title">ข้อควรระวัง</h2>
						<div style={{ width: 10 }} />
						<WarningIcon className="traveler-icon" style={{ color: '#DC1818', marginTop: 3 }} />
					</div>
					<NeedItem
						icon={<NoFoodIcon className="traveler-icon" />}
						value={traveler.cautionFoodAllergic}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('cautionFoodAllergic', value)}
						placeholder="แพ้อาหาร"
					/>
					<NeedItem
						icon={<MedicineIcon className="traveler-icon" />}
						value={traveler.cautionMedicineAllergic}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('cautionMedicineAllergic', value)}
						placeholder="แพ้ยา"
					/>
					<NeedItem
						icon={<RemarkIcon className="traveler-icon" />}
						value={traveler.cautionEtcWarning}
						isEditing={isEditingNeeds}
						onChange={value => handleListChange('cautionEtcWarning', value)}
						placeholder="ข้อควรระวังอื่นๆ"
					/>
				</div>
			</div>
		</div>
	);
};

const NeedItem = ({ icon, value, inputType = 'text', isEditing, onChange, placeholder = '' }) => {
	return (
		<div className="columns" style={{ alignItems: 'center' }}>
			<div className="column is-1 is-centered">{icon}</div>
			<div className="column is-11">
				{isEditing ? (
					<input
						className="input traveler-inline-input is-fullwidth"
						type={inputType}
						value={value}
						onChange={event => onChange(event.target.value)}
						placeholder={placeholder}
					/>
				) : (
					<span
						style={{
							color: value ? 'black' : '#999',
							display: 'block',
							whiteSpace: 'pre-wrap',
							overflowWrap: 'anywhere',
							wordBreak: 'break-word',
						}}
					>
						{value || placeholder}
					</span>
				)}
			</div>
		</div>
	);
};
